import React from 'react';
import MobileStoreButton from 'react-mobile-store-button';
import ModalImage from "react-modal-image";


export default function BodyLayout() {
  const DroidAppUrl = "https://play.google.com/store/apps/details?id=br.com.hondix.revendor";
  // const iOsAppUrl = "https://www.apple.com/br/ios/app-store/";
  const contactPhone = "(35) 99263-1103";
  const mailContact = "atendimento@hondix.com.br";


  const carrouselProducts = [
    {
      text: "Texto de descrição Texto de descrição Texto de descrição Texto de descrição Texto de descrição !",
      title: "Joia 1",
      photo: "https://scontent.frao1-1.fna.fbcdn.net/v/t1.0-9/104215564_702202183933366_1577279012317280684_n.jpg?_nc_cat=107&_nc_sid=a26aad&_nc_ohc=oGsgFlGViWYAX8x3M14&_nc_ht=scontent.frao1-1.fna&oh=50e63b0a95150c4347a7394e9fb5fb29&oe=5F45B967"
    },
    {
      text: "Texto de descrição Texto de descrição Texto de descrição Texto de descrição Texto de descrição ",
      title: "Joia 2",
      photo: "https://scontent.frao1-1.fna.fbcdn.net/v/t1.0-9/104215564_702202183933366_1577279012317280684_n.jpg?_nc_cat=107&_nc_sid=a26aad&_nc_ohc=oGsgFlGViWYAX8x3M14&_nc_ht=scontent.frao1-1.fna&oh=50e63b0a95150c4347a7394e9fb5fb29&oe=5F45B967"
    },
    {
      text: "Texto de descrição Texto de descrição Texto de descrição Texto de descrição Texto de descrição ",
      title: "Joia 3",
      photo: "https://scontent.frao1-1.fna.fbcdn.net/v/t1.0-9/104215564_702202183933366_1577279012317280684_n.jpg?_nc_cat=107&_nc_sid=a26aad&_nc_ohc=oGsgFlGViWYAX8x3M14&_nc_ht=scontent.frao1-1.fna&oh=50e63b0a95150c4347a7394e9fb5fb29&oe=5F45B967"
    },
    {
      text: "Texto de descrição Texto de descrição Texto de descrição Texto de descrição Texto de descrição ",
      title: "Joia 4",
      photo: "https://scontent.frao1-1.fna.fbcdn.net/v/t1.0-9/104215564_702202183933366_1577279012317280684_n.jpg?_nc_cat=107&_nc_sid=a26aad&_nc_ohc=oGsgFlGViWYAX8x3M14&_nc_ht=scontent.frao1-1.fna&oh=50e63b0a95150c4347a7394e9fb5fb29&oe=5F45B967"
    },
  ]



  return (
    <>

      <section className="page-section bg-primary" id="about">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="text-white mt-0">Aplicativo exclusivo para revendedores</h2>
              <hr className="divider light my-4" />
              <p className="text-white-50 mb-4">Controle suas vendas pelo nosso aplicativo!</p>

              <MobileStoreButton
                store="android"
                url={DroidAppUrl}
                linkProps={{ title: 'Android App Hondix' }}
              />

              {/* <MobileStoreButton
                store="ios"
                url="http://playstore.com.br"
                linkProps={{ title: 'iOS App Hondix' }}
              />  */}
            </div>
          </div>
        </div>
      </section>

      {/* Services*/}
      <section className="page-section" id="services">
        <div className="container">
          <h2 className="text-center mt-0">Catálogo</h2>
          <hr className="divider my-4" />
          <div className="row">
            {
              carrouselProducts.map((item, index) => {
                return (
                  <div className="col-lg-3 col-md-6 text-center" key={index}>
                    <div className="mt-5">
                      <ModalImage
                        hideDownload={true}
                        hideZoom={true}
                        className="portfolio-box"
                        small={item.photo}
                        large={item.photo}
                        alt={item.title}
                      />
                      <h3 className="h4 mb-2" style={{ marginTop: 20 }}>{item.title}</h3>
                      <p className="text-muted mb-0">{item.text}</p>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </section>

      {/* Contact*/}
      <section className="page-section" id="contact">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2 className="mt-0">Contato</h2>
              <hr className="divider my-4" />
              <p className="text-muted mb-5">Venha fazer parte de nossa equipe, produtos de qualidade e garantia.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 ml-auto text-center mb-5 mb-lg-0">
              <svg className="svg-inline--fa fa-phone fa-w-16 fa-3x mb-3 text-muted" height="50" width="50" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="phone" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg><path fill="currentColor" d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z" /></svg>{/* <i class="fas fa-phone fa-3x mb-3 text-muted"></i> */}
              <div>{contactPhone}</div>
            </div>

            <div className="col-lg-4 mr-auto text-center">
              <svg height="50" width="50" className="svg-inline--fa fa-envelope fa-w-16 fa-3x mb-3 text-muted" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg>
                <path fill="currentColor" d="M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z" />
              </svg>{/* <i class="fas fa-envelope fa-3x mb-3 text-muted"></i> */}
              {/* Make sure to change the email address in BOTH the anchor text and the link target below!*/}
              <a className="d-block" href="mailto:atendimento@hondix.com.br">{mailContact}</a>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}






